<template>
  <div>
    <div class="k-button k-button-icon chi-audit-button chi-button-attention" @click.prevent="toggle_popup">
      <span role="presentation" class="chi-icon-hourglass-end"></span>
    </div>
    <div class="chi-audit-popup chi-form" :id="popup_id">
      <div class="chi-form-section">
        <div class="chi-form-group" v-for="(field, index) of fields" :key="field.id" :style="index % 2 ? {'margin-right': 0} : {clear: 'left'}">
          <label :for="field.id" :title="components[field.safe_id].hint" role="label" v-html="field.label"></label>
          <br />
          <input
            :id="field.id"
            :class="components[field.safe_id].classes"
            :ref="field.id"
            :style="components[field.safe_id].style"
            :title="components[field.safe_id].hint"
            :value="components[field.safe_id].value"
            readonly
            role="readonlyfield"
            type="text" />
        </div>
      </div>
      <div class="chi-audit-button-section" v-if="button">
        <kendo-button
          :data-safe-id="button.safe_id"
          :data-send="components[button.safe_id].send"
          :id="button.id"
          :class="components[button.safe_id].classes"
          :ref="button.id"
          :style="components[button.safe_id].style"
          :title="components[button.safe_id].hint"
          readonly
          role="button" @click.prevent="on_button_click"><span v-if="!!components[button.safe_id].content" v-html="components[button.safe_id].content.replace(/ /g, '&amp;nbsp;')"></span></kendo-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../scss/_variables.scss";

.chi-audit-button.chi-button-attention {
  background: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  &:hover, &:focus {
    box-shadow: none;
  }
}
.chi-audit-popup.chi-form {
  border: 1px solid $navigation;
  display: none;
  // reset the font settings, inexplicably added to the popup by kendo(?)
  font-family: $font-family !important;
  font-size: $font-size !important;
  font-style: initial !important;
  font-weight: $font-weight-normal !important;
  overflow: auto;
  padding: 1.1434rem;
  padding-top: 0;
  width: auto;
  .chi-audit-button-section {
    float: left;
    height: 9rem;
    margin-left: 1.1434rem;
    position: relative;
    width: 7.643rem;
    .k-button {
      bottom: 0;
      position: absolute;
    }
  }
}
</style>

<script>
import Vue from 'vue';
import $ from 'jquery';
import {Button} from '@progress/kendo-vue-buttons';
import Events from '../js/events';

const REGEXPS = {
  SAFE_ID: /[^a-z0-9$_]/g
};

export default {
  name: 'audit',
  components: {
    'kendo-button': Button
  },
  inject: ['components'],
  props: [
    'createUser', 'createDate', 'createTime', 'lastUser', 'lastDate',
    'lastTime', 'auditButton'
  ],
  data: function () {return {
    button: null,
    fields: [],
    popup_id: null
  }},
  methods: {
    add_field: function (key, props, is_button) {
      var prop = this[key];
      var id = Object.keys(prop)[0];
      var safe_id = 'chi_' + ('' + id).replace(REGEXPS.SAFE_ID, '_');
      var buffer = this.$root.get_props(safe_id);
      var result = {id: id, safe_id: safe_id};
      var shared = (props.shared && this.$root.shared[safe_id]) || {};
      console.debug('adding %s:', safe_id, props, shared, buffer);
      // merge props by priority (buffer is most important, props least)
      Object.assign(props, shared, buffer);
      // copy props into buffer and make shared and props a reference to it,
      // because commands might be holding references to the buffer
      props = Object.assign(buffer, props);
      if (props.shared)
        this.$root.shared[safe_id] = buffer;
      // update props as needed
      if (is_button) {
        props.content = props.content || prop[id].trim();
        props.send = id;
      } else {
        props.value = props.value || '';
        result.label = prop[id].trim();
      }
      Vue.set(this.$root.$options.api.vm.components, safe_id, props);
      return result;
    },
    add_fields: function (prefix) {
      if (this[prefix + 'User']) {
        this.fields.push(this.add_field(prefix + 'User', {
          classes: ['chi-audit-field', 'md', 'k-textbox'],
          style: {},
          hint: ''
        }));
        this.fields.push(this.add_field(prefix + 'Date', {
          classes: [
            'chi-audit-field', 'k-textbox',
            (this[prefix + 'Time'] ? 'lg' : 'sm')
          ],
          style: {},
          hint: ''
        }));
      }
    },
    on_button_click: function (event) {
      this.toggle_popup(event, true);
      Events.on_button_click.call(this, event);
    },
    toggle_popup: function (event, force_close) {
      var button = event.sender ? event.sender.element : $(event.target);
      var popup = $('#' + this.popup_id);
      if (!popup.length)
        return;
      if (!popup.data('kendo-popup'))
        popup.kendoPopup({
          anchor: button,
          animation: {open: {effects: "slideIn:up"}},
          origin: 'top right',
          position: 'bottom right'
        });
      if (popup.css('display') === 'none' && force_close !== true)
        popup.data('kendo-popup').open();
      else
        popup.data('kendo-popup').close();
    }
  },
  mounted: function () {
    console.debug('audit-mounted:', this);
    setImmediate(function (self) {
      self.popup_id = 'chi-audit-popup-' + Math.floor(Math.random() * 1000000);
      self.add_fields('create');
      self.add_fields('last');
      if (self.auditButton)
        self.button = self.add_field('auditButton', {
          classes: ['chi-button-attention'],
          hint: '',
          style: {}
        }, true);
    }, this);
  }
};
</script>
